export const esTranslations: Record<string, string> = {
  nav_home: 'Inicio',
  nav_catalog: 'Catálogo',
  nav_build: 'Arma tu PC',
  nav_offers: 'Ofertas',
  nav_services: 'Servicios',
  nav_about: 'Nosotros',
  nav_book: 'Agendar Cita',
  theme_dark: 'Modo Oscuro',
  theme_light: 'Modo Claro',
  theme_light_btn: 'Claro',
  theme_dark_btn: 'Oscuro',
  cart: 'Carrito',
  add_to_cart: 'Agregar al carrito',
  view_catalog: 'Ver Catálogo',
  contact_us: 'Contáctanos',
  send: 'Enviar',
  loading: 'Cargando...',
  search: 'Buscar...',
  close: 'Cerrar',
  unit_short: 'unid.',
  hero_eyebrow: 'Santo Domingo, República Dominicana',
  hero_title1: 'Súbele el nivel',
  hero_title2: 'a tu experiencia',
  hero_subtitle: 'Hardware gaming premium · Ensamblajes personalizados · Soluciones para empresas',
  hero_cta1: 'Ver Catálogo',
  hero_cta2: 'Solicitar Cotización',
  hero_scroll: 'Scroll',
  stat_clients: 'Clientes satisfechos',
  stat_products: 'Productos en catálogo',
  stat_years: 'Años de experiencia',
  stat_rating: 'Calificación promedio',
  new_badge: 'Novedades',
  new_title: 'Nuevos Ingresos',
  new_subtitle: 'Componentes y periféricos gaming recién llegados al inventario',
  new_cta: 'Ver Todo el Catálogo',
  builder_badge: 'Configurador',
  builder_title: 'Arma tu PC',
  builder_title_accent: 'a la medida',
  builder_subtitle: 'Elige cada componente, revisa la compatibilidad en tiempo real y obtén tu presupuesto en segundos.',
  builder_cta: 'Iniciar Configuración',
  services_badge: 'Lo que hacemos',
  services_title: 'Servicios',
  services_title_accent: 'SpartechRD',
  services_subtitle: 'Soluciones completas para hardware, software y soporte técnico',
  about_badge: 'Nuestra historia',
  about_title: 'Sobre',
  about_title_accent: 'Nosotros',
  contact_badge: 'Escríbenos',
  contact_title: 'Contáctanos',
  contact_subtitle: 'Estamos aquí para ayudarte con cualquier duda sobre hardware, servicios o cotizaciones',
  contact_name: 'Nombre',
  contact_email: 'Correo Electrónico',
  contact_phone: 'Teléfono',
  contact_message: 'Mensaje',
  contact_send: 'Enviar Mensaje',
  footer_about: 'Tu aliado tecnológico en RD desde 2013. Hardware gaming, ensamblajes y soporte técnico profesional en Santo Domingo Este.',
  footer_nav: 'Navegación',
  footer_contact: 'Contacto',
  footer_location: 'Ubicación y Horario',
  footer_rights: 'Todos los derechos reservados.',
  footer_system: 'Sistema Operativo',
  footer_mon_fri: 'Lun – Sáb',
  footer_sat: 'Sábado',
  footer_sun: 'Domingo',
  footer_closed: 'Cerrado',
  book_title: 'Agenda tu',
  book_title_accent: 'Visita',
  book_subtitle: 'Selecciona fecha y hora para que uno de nuestros técnicos certificados te atienda',
  catalog_title: 'Nuestro',
  catalog_title_accent: 'Catálogo',
  catalog_search: 'Buscar productos...',
  catalog_filter: 'Filtrar',
  catalog_sort: 'Ordenar',
  catalog_all: 'Todos',
  catalog_showing: 'Mostrando',
  catalog_of: 'de',
  catalog_products: 'productos',
  product_add_cart: 'Agregar al carrito',
  product_quote_wa: 'Cotizar por WhatsApp',
  product_specs: 'Especificaciones',
  product_in_stock: 'En stock',
  product_out_stock: 'Sin stock',
  cart_title: 'Tu Carrito',
  cart_empty: 'Tu carrito está vacío',
  cart_total: 'Total',
  cart_checkout: 'Finalizar por WhatsApp',
  cart_clear: 'Vaciar carrito',
  tracking_title: 'Seguimiento de',
  tracking_accent: 'Equipo',
  tracking_subtitle: 'Ingresa tu número de ticket para ver el estado de tu equipo',
  tracking_placeholder: 'Ej: SPT-12345',
  tracking_search_btn: 'Buscar',
  faq_badge: 'Preguntas frecuentes',
  faq_title_1: 'Todo lo que',
  faq_title_2: 'necesitas saber',
  faq_subtitle: 'Resolvemos tus dudas sobre compras, envíos, garantías, ensamblajes y más.',
  faq_more: '¿Otra pregunta?',
  faq_q1: '¿Hacen envíos a toda la República Dominicana?',
  faq_a1: 'Sí, realizamos envíos a todo el territorio nacional. Trabajamos con empresas de mensajería confiables y puedes elegir entre entrega estándar (2-5 días) o express (1-2 días). Los pedidos mayores a RD$5,000 tienen envío gratuito dentro del Gran Santo Domingo.',
  faq_q2: '¿Ofrecen garantía en los productos?',
  faq_a2: 'Todos nuestros productos cuentan con garantía oficial del fabricante. Las tarjetas gráficas y procesadores tienen garantía de 1-3 años, las memorias y SSDs de 3-5 años, y los periféricos de 1-2 años. Los ensamblajes personalizados incluyen garantía adicional de SpartechRD por 1 año.',
  faq_q3: '¿Puedo pagar a plazos o en cuotas?',
  faq_a3: 'Sí, aceptamos pagos fraccionados a través de varias entidades bancarias dominicanas. Puedes financiar tu compra en 3, 6 o 12 cuotas con tarjetas de crédito. También ofrecemos planes corporativos para empresas que requieran grandes cantidades de equipos.',
  faq_q4: '¿Cuánto tiempo tarda un ensamblaje personalizado?',
  faq_a4: 'El tiempo de ensamblaje varía según la complejidad del build y la disponibilidad de los componentes. Generalmente, un ensamblaje completo toma entre 3 a 7 días hábiles. Incluimos pruebas de estrés de 24 horas antes de entregar cualquier PC ensamblada.',
  faq_q5: '¿Tienen servicio técnico y reparación?',
  faq_a5: 'Contamos con un equipo técnico certificado para diagnóstico, reparación y mantenimiento de equipos. Ofrecemos servicio in-situ para clientes corporativos en Santo Domingo y llevamos equipos para reparación en nuestro taller. Los presupuestos de reparación son sin compromiso.',
  faq_q6: '¿Puedo visitar la tienda física?',
  faq_a6: 'Absolutamente. Nuestra tienda está ubicada en C/Octavio Mejía Ricart Esq. C/Aruba #18A, Ensanche Ozama, Santo Domingo Este. Estamos abiertos de lunes a sábado de 9:00 AM a 6:00 PM. Domingos y feriados cerrados. Te recomendamos llamar antes si deseas una asesoría personalizada.',
  faq_q7: '¿Aceptan devoluciones o cambios?',
  faq_a7: 'Aceptamos devoluciones dentro de los primeros 7 días si el producto presenta defectos de fábrica o no funciona correctamente. Los cambios por preferencia personal se pueden realizar dentro de los primeros 3 días si el producto no ha sido abierto.',
  faq_q8: '¿Trabajan con empresas y corporaciones?',
  faq_a8: 'Sí, tenemos un área especializada para clientes corporativos. Ofrecemos precios especiales por volumen, planes de mantenimiento periódico, facturación con comprobante fiscal (NCF), y podemos diseñar soluciones tecnológicas completas para empresas de cualquier tamaño.',
  reviews_title: 'Nuestros',
  reviews_accent: 'Clientes',
  reviews_subtitle: 'Opiniones reales de quienes ya alcanzaron el siguiente nivel',
  new_label: 'Recién llegados',
  new_heading1: 'Lo más',
  new_heading2: 'Nuevo',
  new_see_all: 'Ver todo el catálogo',
  new_add_cart: 'Agregar al carrito',
  new_in_stock: 'En stock',
  new_out_stock: 'Sin stock',
  new_on_request: 'A consultar',
  builder_new_label: 'Nuevo',
  builder_teaser_title1: 'Configura tu',
  builder_teaser_title2: 'PC Ideal',
  builder_teaser_body: 'Usa nuestro configurador paso a paso para armar la PC perfecta para gaming, trabajo creativo u oficina. Verificación de compatibilidad en tiempo real y cotización directa.',
  builder_compat: 'Compatibilidad automática',
  builder_realtime: 'Precios en tiempo real',
  builder_assembly: 'Ensamblaje profesional',
  builder_wa_quote: 'Cotización por WhatsApp',
  builder_step_cpu: 'Elige tu CPU',
  builder_step_mobo: 'Tarjeta Madre',
  builder_step_ramgpu: 'RAM & GPU',
  builder_step_quote: 'Cotiza al instante',
  builder_start: 'Comenzar a Configurar',
  contact_heading1: 'Hablemos de tu',
  contact_heading2: 'próximo setup',
  contact_body: 'Nuestro equipo está listo para asesorarte en la compra de componentes, ensamblajes personalizados o soluciones tecnológicas para tu empresa.',
  contact_phone_label: 'Teléfono',
  contact_location_label: 'Ubicación',
  contact_hours_label: 'Horarios',
  contact_wa_label: 'WhatsApp',
  contact_wa_cta: 'Chatea con un agente →',
  contact_hours_val: 'Lun – Sáb: 9:00 AM a 6:00 PM',
  contact_hours_closed: 'Domingos y feriados: Cerrado',
  contact_location_val: 'C/Octavio Mejía Ricart Esq. C/ Aruba #18A, Ens. Ozama, Santo Domingo Este, RD',
  contact_form_title: 'Envíanos un mensaje',
  contact_subject_label: 'Asunto',
  contact_send_btn: 'Enviar Mensaje',
  contact_sending: 'Enviando...',
  contact_success_title: '¡Mensaje enviado!',
  contact_success_desc: 'Nos pondremos en contacto contigo a la brevedad. ¡Gracias!',
  contact_another: 'Enviar otro mensaje',
  contact_error: 'Hubo un error al enviar. Por favor inténtalo de nuevo.',
  contact_disclaimer: 'Al enviar aceptas que un técnico SpartechRD te contacte para coordinar el servicio.',
  tracking_notify_title: 'Recibe notificaciones',
  tracking_notify_desc: 'Te avisamos cuando tu ticket cambie de estado',
  tracking_notify_wa: 'Notificarme por WhatsApp',
  tracking_notify_email_ph: 'tu@correo.com',
  tracking_notify_email_btn: 'Suscribir',
  tracking_notify_success: '¡Listo! Te notificaremos al detectar cambios en tu ticket.',
  tracking_notify_or: 'o',
  latest_badge: 'Lo más reciente',
  latest_title1: 'Últimos',
  latest_title2: 'Productos',
  latest_subtitle: 'Descubre hardware de alto rendimiento para llevar tu setup al siguiente nivel',
  latest_view_catalog: 'Ver en Catálogo',
  latest_view_all: 'Ver catálogo completo',
  latest_new_badge: 'Nuevo',
  svc_hero_badge: 'Servicios Profesionales',
  svc_hero_title1: 'Soluciones',
  svc_hero_title2: 'Técnicas',
  svc_hero_title3: 'de Élite',
  svc_hero_subtitle: 'Ensamblaje personalizado, mantenimiento preventivo y soporte técnico especializado en Santo Domingo. Más de 10 años resolviendo problemas de hardware y software.',
  svc_hero_cta1: 'Solicitar Servicio',
  svc_hero_cta2: 'Hablar con un Técnico',
  svc_stat_built: 'PCs ensambladas',
  svc_stat_time: 'Tiempo promedio',
  svc_stat_warranty: 'Garantía incluida',
  svc_stat_warranty_val: '1 año',
  svc_stat_rating: 'Clientes satisfechos',
  svc_pkg_badge: 'Nuestros Servicios',
  svc_pkg_title: 'Elige tu',
  svc_pkg_title_accent: 'Plan',
  svc_pkg_subtitle: 'Planes diseñados para cada necesidad, desde usuarios individuales hasta empresas.',
  svc_tab_assembly: 'Ensamblaje',
  svc_tab_maintenance: 'Mantenimiento',
  svc_tab_support: 'Soporte Técnico',
  svc_specialized: 'Servicio especializado',
  svc_process_badge: 'Proceso',
  svc_process_title: 'Cómo',
  svc_process_title_accent: 'Trabajamos',
  svc_process_subtitle: 'Proceso claro y transparente de inicio a fin',
  svc_step1_title: 'Solicita el Servicio',
  svc_step1_desc: 'Llena el formulario indicando el tipo de servicio, descripción del equipo y disponibilidad horaria.',
  svc_step1_detail: 'Respuesta en menos de 2 horas en horario laboral.',
  svc_step2_title: 'Diagnóstico y Cotización',
  svc_step2_desc: 'Nuestro técnico evalúa el caso y te envía una cotización detallada sin compromiso.',
  svc_step2_detail: 'El diagnóstico presencial tiene un costo de RD$500 que se descuenta del servicio.',
  svc_step3_title: 'Ejecución del Trabajo',
  svc_step3_desc: 'Con tu aprobación, el técnico realiza el servicio con los más altos estándares de calidad.',
  svc_step3_detail: 'Tiempo estimado informado antes de comenzar. Actualizaciones en tiempo real.',
  svc_step4_title: 'Entrega y Garantía',
  svc_step4_desc: 'Recibe tu equipo funcionando al 100% con informe técnico y garantía documentada.',
  svc_step4_detail: 'Garantía de 30 a 90 días según el tipo de servicio realizado.',
  svc_g1_title: 'Respuesta en 2h',
  svc_g1_desc: 'Confirmación de tu solicitud en horario laboral',
  svc_g2_title: 'Técnicos Certificados',
  svc_g2_desc: 'Personal con +5 años de experiencia comprobada',
  svc_g3_title: 'Datos Protegidos',
  svc_g3_desc: 'Política de confidencialidad estricta en todos los trabajos',
  svc_g4_title: 'Satisfacción Garantizada',
  svc_g4_desc: 'Si no quedas conforme, lo resolvemos sin costo adicional',
  svc_form_badge: 'Formulario',
  svc_form_title: 'Solicita tu',
  svc_form_title_accent: 'Servicio',
  svc_form_subtitle: 'Completa el formulario y un técnico especializado te contactará en menos de 2 horas en horario laboral.',
  svc_form_contact_ch: 'Canales de Contacto',
  svc_form_hours: 'Horario de Atención',
  svc_form_h1: 'Lunes – Sábado',
  svc_form_t1: '9:00 AM – 6:00 PM',
  svc_form_h2: 'Domingo y feriados',
  svc_form_t2: 'Cerrado',
  svc_form_h3: '',
  svc_form_t3: '',
  svc_form_heading: 'Datos de la Solicitud',
  svc_form_name: 'Nombre',
  svc_form_name_ph: 'Tu nombre completo',
  svc_form_email: 'Email',
  svc_form_phone: 'Teléfono',
  svc_form_phone_ph: '(809) 000-0000',
  svc_form_company: 'Empresa',
  svc_form_company_ph: 'Opcional',
  svc_form_service: 'Tipo de Servicio',
  svc_form_service_ph: 'Seleccionar...',
  svc_form_service_1: 'Ensamblaje de PCs',
  svc_form_service_2: 'Mantenimiento Preventivo',
  svc_form_service_3: 'Soporte Técnico Remoto',
  svc_form_service_4: 'Soporte Técnico Presencial',
  svc_form_service_5: 'Plan SLA Empresarial',
  svc_form_service_6: 'Contrato de Mantenimiento',
  svc_form_service_7: 'Otro',
  svc_form_plan: 'Plan / Modalidad',
  svc_form_plan_ph: 'Sin preferencia',
  svc_form_plan_1: 'Básico',
  svc_form_plan_2: 'Pro / Completo',
  svc_form_plan_3: 'Empresarial / Contrato',
  svc_form_qty: 'Cantidad de Equipos',
  svc_form_qty_1: '1 equipo',
  svc_form_qty_2: '2 – 5 equipos',
  svc_form_qty_3: '6 – 20 equipos',
  svc_form_qty_4: '21 – 50 equipos',
  svc_form_qty_5: 'Más de 50',
  svc_form_urgency: 'Urgencia',
  svc_form_urgency_1: 'Normal (1-3 días)',
  svc_form_urgency_2: 'Urgente (mismo día)',
  svc_form_urgency_3: 'Programar fecha',
  svc_form_location: 'Ubicación / Sector',
  svc_form_location_ph: 'Ej: Santo Domingo Este, Los Minas...',
  svc_form_desc: 'Descripción del Problema / Requerimiento',
  svc_form_desc_ph: 'Describe el problema, síntomas, equipo afectado, o qué necesitas hacer...',
  svc_form_pref: 'Preferencia de Contacto',
  svc_form_pref_call: 'Llamada',
  svc_form_submit: 'Enviar Solicitud de Servicio',
  svc_form_submitting: 'Enviando...',
  svc_form_success_title: '¡Solicitud Enviada!',
  svc_form_success_desc: 'Un técnico revisará tu solicitud y se pondrá en contacto contigo en menos de 2 horas en horario laboral.',
  svc_form_success_wa: 'Confirmar por WhatsApp',
  svc_form_another: 'Enviar otra solicitud',
  svc_form_error: 'Error al enviar. Por favor inténtalo de nuevo.',
  svc_form_disclaimer: 'Al enviar aceptas que un técnico SpartechRD te contacte para coordinar el servicio.',
  news_section_badge: 'Mantente al día',
  news_section_title: 'Noticias',
  news_section_title_accent: 'Gaming & Tech',
  news_section_subtitle: 'Lo último en hardware, gaming y tecnología que impacta directamente lo que vendemos',
  news_read_more: 'Leer más',
  news_read_time: 'lectura',
  cat_all: 'Todos',
  cat_gpu: 'Tarjetas Gráficas',
  cat_cpu: 'Procesadores',
  cat_ram: 'Memorias RAM',
  cat_storage: 'Almacenamiento',
  cat_chairs: 'Sillas Gaming',
  cat_monitors: 'Monitores',
  cat_accessories: 'Accesorios',
  cat_builds: 'Ensamblajes',
  product_no_stock_btn: 'Sin disponibilidad',
  product_add_cart_btn: 'Al carrito',
  product_view_detail: 'Ver detalle',
  product_featured_badge: 'Destacado',
  product_on_request: 'A consultar',
  product_add_compare_tip: 'Agregar a comparación',
  product_in_compare_label: 'En comparación',
  product_cat_gpu: 'Tarjeta Gráfica',
  product_cat_cpu: 'Procesador',
  product_cat_ram: 'Memoria RAM',
  product_cat_storage: 'Almacenamiento',
  product_cat_chairs: 'Silla Gaming',
  product_cat_monitors: 'Monitor',
  product_cat_accessories: 'Accesorio',
  product_cat_builds: 'Ensamblaje',
  catalog_hero_badge: 'SpartechRD',
  catalog_hero_title: 'Catálogo',
  catalog_hero_title_accent: 'Completo',
  catalog_hero_subtitle: 'Hardware gaming, sillas, monitores y ensamblajes a tu medida — actualizado en tiempo real',
  catalog_sort_relevance: 'Relevancia',
  catalog_sort_price_asc: 'Precio: menor a mayor',
  catalog_sort_price_desc: 'Precio: mayor a menor',
  catalog_sort_name: 'Nombre A-Z',
  catalog_result_loading: 'Cargando productos...',
  catalog_result_of_label: 'de',
  catalog_live_label: 'En vivo',
  catalog_updated_label: 'Act.',
  catalog_no_match: 'No hay productos con ese filtro',
  catalog_no_match_sub: 'Prueba con otras palabras o limpia los filtros',
  catalog_clear_filters: 'Limpiar filtros',
  catalog_retry: 'Reintentar',
  catalog_error_msg: 'Error al cargar los productos',
  catalog_unit: 'producto',
  catalog_units: 'productos',
  offers_hero_badge: 'Por tiempo limitado',
  offers_hero_title: 'Ofertas',
  offers_hero_title_accent: 'Vigentes',
  offers_hero_subtitle: 'Descuentos activos en hardware y componentes — aprovéchalos antes de que terminen',
  offers_count_one: 'producto en oferta',
  offers_count_many: 'productos en oferta',
  offers_view_all: 'Ver todas las ofertas',
  offers_empty_title: 'No hay ofertas vigentes en este momento',
  offers_empty_sub: 'Vuelve pronto — actualizamos las promociones con frecuencia',
  arma_badge: 'Configurador en Tiempo Real',
  arma_title1: 'Arma tu',
  arma_title2: 'PC Perfecta',
  arma_subtitle: 'Elige cada componente paso a paso. Compatibilidad automática, precios en tiempo real, cotización directa.',
  arma_preset_popular: 'Popular',
  arma_preset_selected: 'Seleccionado',
  arma_preset1_name: 'PC Gaming Básica',
  arma_preset2_name: 'Workstation Creativo',
  arma_preset3_name: 'PC Ultra Gaming 4K',
  arma_preset4_name: 'PC Oficina Pro',
  arma_search_ph: 'Buscar componente...',
  arma_sort_perf: 'Rendimiento',
  arma_sort_price: 'Precio ↑',
  arma_sort_rating: 'Valoración',
  arma_compat_toggle: 'Solo compatibles',
  arma_step_label: 'Paso',
  arma_step_of: 'de',
  arma_prev: 'Anterior',
  arma_next: 'Siguiente',
  arma_no_compat: 'No se encontraron componentes compatibles',
  arma_show_all: 'Ver todos',
  arma_realtime_badge: 'Configurador en Tiempo Real',
  arma_why_title: '¿Por qué armar con',
  arma_why_brand: 'SpartechRD',
  arma_why_f1_title: 'Ensamblaje Profesional',
  arma_why_f1_desc: 'Técnicos certificados con +10 años de experiencia',
  arma_why_f2_title: 'Garantía de 1 Año',
  arma_why_f2_desc: 'Cobertura completa en piezas y mano de obra',
  arma_why_f3_title: 'Soporte Post-Venta',
  arma_why_f3_desc: 'Asistencia técnica remota y presencial',
  arma_why_f4_title: 'Entrega en 48h',
  arma_why_f4_desc: 'Envío nacional y entrega en Santo Domingo',
  build_sum_title: 'Tu Configuración',
  build_sum_components: 'componentes',
  build_sum_ready: 'listo',
  build_sum_none: 'Sin seleccionar',
  build_sum_perf: 'Rendimiento Estimado',
  build_sum_value: 'Relación Valor',
  build_sum_watt: 'Consumo estimado',
  build_sum_psu_warn: '⚠ Fuente insuficiente',
  build_sum_total: 'Total estimado',
  build_sum_preview: 'Ver Vista Previa del Build',
  build_sum_wa: 'Cotizar por WhatsApp',
  build_sum_clear: 'Limpiar configuración',
  build_sum_selected: '✓ Seleccionado',
  seg_hero_badge: 'Seguimiento de Ticket',
  seg_hero_title: 'Rastrea tu',
  seg_hero_title_accent: 'Servicio',
  seg_hero_subtitle: 'Ingresa tu número de ticket para ver el estado actual de tu equipo.',
  seg_ticket_note: 'El número de ticket fue enviado a tu email y WhatsApp al agendar la cita.',
  seg_search_btn: 'Buscar',
  seg_demo_note: 'Tickets de demostración disponibles:',
  seg_not_found_title: 'Ticket no encontrado',
  seg_not_found_sub: 'No encontramos el ticket',
  seg_wa_consult: 'Consultar por WhatsApp',
  seg_result_client: 'Cliente',
  seg_result_received_label: 'Recibido:',
  seg_result_view_full: 'Ver Detalles Completos',
  seg_status_title: 'Estado del Servicio',
  seg_in_progress_badge: 'En Curso',
  seg_completed_badge: '✓ Completado',
  seg_tech_label: 'Técnico Asignado',
  seg_tech_note_label: 'Nota del Técnico',
  seg_ready_title: '¡Tu equipo está listo!',
  seg_ready_desc: 'Puedes pasar a recogerlo en nuestro local en Santo Domingo Este.',
  seg_ready_wa: 'Coordinar Entrega',
  seg_questions: '¿Tienes preguntas sobre tu servicio?',
  seg_ask_ticket: 'Preguntar sobre mi ticket',
  seg_wa_ask: 'Preguntar por WhatsApp',
  seg_step1_label: 'Recibido',
  seg_step1_desc: 'Equipo recibido en tienda',
  seg_step2_label: 'En Diagnóstico',
  seg_step2_desc: 'Técnico evaluando el equipo',
  seg_step3_label: 'En Reparación',
  seg_step3_desc: 'Trabajo en proceso',
  seg_step4_label: 'Pruebas de Calidad',
  seg_step4_desc: 'Verificando funcionamiento',
  seg_step5_label: 'Listo para Entrega',
  seg_step5_desc: 'Puedes recoger tu equipo',
  seg_modal_title: 'Detalles del Pedido',
  seg_modal_service: 'Servicio',
  seg_modal_device: 'Dispositivo',
  seg_modal_client: 'Cliente',
  seg_modal_date: 'Fecha Recibido',
  seg_modal_current: 'Estado Actual',
  seg_modal_progress: 'Progreso del Servicio',
  seg_modal_wa: 'Preguntar por WhatsApp',
  seg_modal_close: 'Cerrar',
  seg_modal_ready: '¡Listo para entrega!',
  seg_modal_ready_desc: 'Tu equipo está listo para ser retirado en tienda.',
  comp_perf: 'Rendimiento',
  comp_available: 'disp.',
  comp_out_stock: 'Agotado',
  stories_badge: 'Casos de éxito',
  stories_title1: 'Empresas que confían',
  stories_title2: 'en SpartechRD',
  stories_sub: 'De la construcción a la seguridad nacional — marcas líderes de República Dominicana eligen SpartechRD para su infraestructura tecnológica.',
  stories_paused: 'Pausado',
  step_cpu_label: 'Procesador',
  step_cpu_desc: 'El cerebro de tu PC',
  step_motherboard_label: 'Tarjeta Madre',
  step_motherboard_desc: 'La base que conecta todo',
  step_ram_label: 'Memoria RAM',
  step_ram_desc: 'Velocidad y multitarea',
  step_gpu_label: 'Tarjeta Gráfica',
  step_gpu_desc: 'Potencia visual y gaming',
  step_storage_label: 'Almacenamiento',
  step_storage_desc: 'Velocidad de carga y espacio',
  step_psu_label: 'Fuente de Poder',
  step_psu_desc: 'Energía estable y eficiente',
  step_case_label: 'Gabinete',
  step_case_desc: 'Estilo y flujo de aire',
  step_cooling_label: 'Enfriamiento',
  step_cooling_desc: 'Temperaturas bajo control',
  nos_hero_badge: 'Nuestra Historia',
  nos_hero_title_pre: 'Más de 10 Años',
  nos_hero_title_hl: 'transformando',
  nos_hero_title_post: 'tecnología en la RD',
  nos_hero_sub: 'Somos el aliado tecnológico de empresas y gamers en República Dominicana desde 2013. Construimos relaciones duraderas basadas en confianza, calidad y pasión por la tecnología.',
  nos_stat1_v: '10+',
  nos_stat1_l: 'Años de experiencia',
  nos_stat2_v: '500+',
  nos_stat2_l: 'Clientes satisfechos',
  nos_stat3_v: '3,500+',
  nos_stat3_l: 'Equipos atendidos',
  nos_stat4_v: '4.9',
  nos_stat4_l: 'Calificación promedio',
  nos_mission_title: 'Misión',
  nos_mission_desc: 'Proveer hardware tecnológico de calidad y servicios técnicos especializados que transformen la experiencia digital de nuestros clientes, con transparencia y excelencia en cada proyecto.',
  nos_vision_title: 'Visión',
  nos_vision_desc: 'Ser la empresa tecnológica de referencia en República Dominicana, reconocida por la calidad de nuestros productos, la excelencia de nuestro equipo y el impacto positivo en la comunidad tech local.',
  nos_purpose_title: 'Propósito',
  nos_purpose_desc: 'Democratizar el acceso a tecnología de alto rendimiento en República Dominicana, brindando asesoría experta y productos de calidad a precios justos.',
  nos_val1: 'Excelencia',
  nos_val1_desc: 'No aceptamos mediocridad en ningún servicio o producto',
  nos_val2: 'Honestidad',
  nos_val2_desc: 'Transparencia total con cada cliente, siempre',
  nos_val3: 'Innovación',
  nos_val3_desc: 'Siempre a la vanguardia de la tecnología',
  nos_val4: 'Comunidad',
  nos_val4_desc: 'Construyendo el ecosistema tech dominicano',
  nos_tl1_year: '2013',
  nos_tl1_title: 'Fundación de SpartechRD',
  nos_tl1_desc: 'Iniciamos operaciones en Santo Domingo Este con un pequeño taller de reparación de computadoras.',
  nos_tl2_year: '2015',
  nos_tl2_title: 'Primera Tienda Física',
  nos_tl2_desc: 'Abrimos nuestro primer local comercial en Ensanche Ozama, ampliando el catálogo de hardware.',
  nos_tl3_year: '2017',
  nos_tl3_title: 'Especialización Gaming',
  nos_tl3_desc: 'Nos posicionamos como referentes del hardware gaming en Santo Domingo, atrayendo a la comunidad gamer local.',
  nos_tl4_year: '2019',
  nos_tl4_title: 'Expansión Empresarial',
  nos_tl4_desc: 'Lanzamos soluciones para empresas: contratos de mantenimiento, instalaciones en red y soporte SLA.',
  nos_tl5_year: '2021',
  nos_tl5_title: 'Plataforma E-Commerce',
  nos_tl5_desc: 'Lanzamos nuestra tienda online permitiendo compras y cotizaciones desde toda la República Dominicana.',
  nos_tl6_year: '2023',
  nos_tl6_title: '10 Años & Reconocimiento',
  nos_tl6_desc: 'Celebramos una década de operaciones con más de 200 empresas clientes y 3,500 equipos atendidos.',
  nos_member1_name: 'Carlos Martínez',
  nos_member1_role: 'CEO & Fundador',
  nos_member1_desc: 'Más de 15 años en el sector tecnológico. Visionario del hardware gaming en RD.',
  nos_member2_name: 'Luis Rodríguez',
  nos_member2_role: 'Técnico Principal',
  nos_member2_desc: 'Especialista en ensamblajes de alto rendimiento y overclocking. A+ Certified.',
  nos_member3_name: 'Ana García',
  nos_member3_role: 'Gerente de Ventas',
  nos_member3_desc: 'Experta en soluciones empresariales y relaciones con clientes corporativos.',
  nos_member4_name: 'Miguel Santos',
  nos_member4_role: 'Técnico Senior',
  nos_member4_desc: 'Especializado en reparación de laptops, diagnóstico avanzado y soporte técnico.',
  nos_co1_name: 'Constructora Sanval',
  nos_co1_sector: 'Construcción',
  nos_co1_desc: 'Equipamos las oficinas con estaciones de trabajo de alto rendimiento para gestión de proyectos.',
  nos_co2_name: 'Blink Gaming',
  nos_co2_sector: 'Entretenimiento',
  nos_co2_desc: 'Proveemos hardware gaming para sus torneos y salas de gaming en Santo Domingo.',
  nos_co3_name: 'Alofoke Media',
  nos_co3_sector: 'Medios & Streaming',
  nos_co3_desc: 'Montamos sus estaciones de edición y streaming con componentes profesionales de última generación.',
  nos_co4_name: '9-1-1 Emergencias',
  nos_co4_sector: 'Seguridad Nacional',
  nos_co4_desc: 'Infraestructura tecnológica crítica para el sistema nacional de emergencias de RD.',
  nos_timeline_badge: 'Nuestra trayectoria',
  nos_timeline_title1: 'Historia de',
  nos_timeline_title2: 'SpartechRD',
  nos_team_badge: 'El equipo detrás',
  nos_team_title1: 'Nuestro',
  nos_team_title2: 'Equipo',
  nos_co_badge: 'Clientes corporativos',
  nos_co_title1: 'Empresas que',
  nos_co_title2: 'Confían',
  nos_co_title3: 'en Nosotros',
  nos_cta_title1: '¿Listo para el',
  nos_cta_title2: 'siguiente nivel?',
  nos_cta_sub: 'Agenda una visita, cotiza tu PC ideal o simplemente escríbenos por WhatsApp. Estamos aquí para transformar tu experiencia tecnológica.',
  nos_cta_btn1: 'Agendar Cita',
  nos_cta_btn2: 'Escribir por WhatsApp',
  svc_exp_badge: 'Nuestra Experiencia',
  svc_exp_title1: 'Más de',
  svc_exp_title2: '10 Años',
  svc_exp_title3: 'resolviendo problemas tecnológicos',
  svc_exp_desc: 'SpartechRD lleva más de una década siendo el aliado tecnológico de empresas y usuarios particulares en la República Dominicana. Nuestros técnicos están en constante actualización con las últimas tecnologías del mercado.',
  svc_exp_stat1_l: 'Empresas atendidas',
  svc_exp_stat2_l: 'Equipos reparados',
  svc_exp_stat3_l: 'PCs ensambladas',
  svc_exp_stat4_l: 'Calificación promedio',
  svc_faq_section_badge: 'FAQ',
  svc_faq_section_title: 'Preguntas Frecuentes',
  svc_faq_q1: '¿Cuánto tiempo tarda un ensamblaje profesional?',
  svc_faq_a1: 'Un ensamblaje Pro toma entre 24 y 48 horas. Si los componentes son provistos por el cliente, podemos tenerlo listo el mismo día en algunos casos.',
  svc_faq_q2: '¿Ofrecen servicio a domicilio?',
  svc_faq_a2: 'Sí, el plan de soporte técnico presencial incluye visita a tu ubicación en Santo Domingo y alrededores. Para zonas fuera del Gran Santo Domingo aplica cargo adicional por desplazamiento.',
  svc_faq_q3: '¿Qué incluye la garantía de servicio?',
  svc_faq_a3: 'La garantía cubre la mano de obra del trabajo realizado (30 a 90 días según el plan). Los componentes nuevos vienen con garantía del fabricante adicional.',
  svc_faq_q4: '¿Pueden mantener equipos de marca como HP, Dell, Lenovo?',
  svc_faq_a4: 'Absolutamente. Atendemos equipos de todas las marcas, tanto desktops como laptops, para uso personal y empresarial.',
  svc_faq_q5: '¿Cómo funciona el soporte remoto?',
  svc_faq_a5: 'Usamos herramientas seguras como TeamViewer o AnyDesk. Solo tienes que descargar el software, compartir el código de acceso con nuestro técnico, y él puede resolver el problema desde nuestra oficina.',
  svc_asm_title: 'Ensamblaje de PCs',
  svc_asm_subtitle: 'Armamos tu PC exactamente como la soñaste, con componentes verificados y garantía total.',
  svc_mnt_title: 'Mantenimiento Preventivo',
  svc_mnt_subtitle: 'Prolonga la vida útil de tus equipos y mantén el máximo rendimiento con nuestros planes de mantenimiento.',
  svc_sup_title: 'Soporte Técnico',
  svc_sup_subtitle: 'Resolvemos cualquier problema de hardware, software o red. Presencial o remoto, cuando lo necesites.',
  svc_pkg_basic: 'Básico',
  svc_pkg_pro: 'Pro',
  svc_pkg_enterprise: 'Empresarial',
  svc_pkg_deep: 'Profundo',
  svc_pkg_contract: 'Contrato Empresarial',
  svc_pkg_remote: 'Remoto',
  svc_pkg_onsite: 'Presencial',
  svc_pkg_sla: 'Plan SLA Mensual',
  svc_pkg_cta_request: 'Solicitar',
  svc_pkg_cta_request_now: 'Solicitar Ahora',
  svc_pkg_cta_request_quote: 'Solicitar Cotización',
  svc_pkg_cta_schedule: 'Agendar',
  svc_pkg_cta_schedule_now: 'Agendar Ahora',
  svc_pkg_cta_proposal: 'Ver Propuesta',
  svc_pkg_cta_connect: 'Conectar Ahora',
  svc_pkg_cta_visit: 'Agendar Visita',
  svc_pkg_cta_sla: 'Solicitar SLA',
  svc_pkg_badge_popular: 'Popular',
  svc_pkg_badge_complete: 'Más Completo',
  svc_pkg_badge_recommended: 'Recomendado',
  svc_find_us: 'Encuéntranos',
  quote_badge: 'Cotizaciones',
  quote_title: 'Solicita tu',
  quote_title_accent: 'Cotización',
  quote_subtitle: 'Descríbenos tu proyecto o necesidad y te respondemos en menos de 24 horas con la mejor propuesta del mercado.',
  quote_why: '¿Por qué elegir SpartechRD?',
  quote_b1: 'Garantía oficial en todos los productos',
  quote_b2: 'Envíos a toda la República Dominicana',
  quote_b3: 'Asesoría técnica personalizada sin costo',
  quote_b4: 'Servicio de ensamblaje y configuración incluido',
  quote_b5: 'Planes especiales para empresas y corporaciones',
  quote_direct: 'Contacto directo',
  quote_form_title: 'Formulario de cotización',
  quote_name: 'Nombre *',
  quote_name_ph: 'Tu nombre',
  quote_email: 'Email *',
  quote_phone: 'Teléfono',
  quote_company: 'Empresa',
  quote_company_ph: 'Tu empresa (opcional)',
  quote_type: 'Tipo de cotización *',
  quote_type_ph: 'Selecciona...',
  quote_t1: 'Componentes específicos',
  quote_t2: 'Ensamblaje personalizado',
  quote_t3: 'Solución para empresa',
  quote_t4: 'Servicio técnico',
  quote_t5: 'Compra al por mayor',
  quote_budget: 'Presupuesto aproximado',
  quote_budget_ph: 'Prefiero no especificar',
  quote_budget_1: 'Menos de RD$20,000',
  quote_budget_2: 'RD$20,000 – RD$50,000',
  quote_budget_3: 'RD$50,000 – RD$150,000',
  quote_budget_4: 'RD$150,000 – RD$500,000',
  quote_budget_5: 'Más de RD$500,000',
  quote_desc: 'Descripción del proyecto *',
  quote_desc_ph: 'Describe lo que necesitas: equipos, cantidad, especificaciones, fecha requerida...',
  quote_error: 'Error al enviar. Por favor inténtalo de nuevo.',
  quote_submit: 'Solicitar Cotización',
  quote_sending: 'Enviando...',
  quote_success_title: '¡Cotización enviada!',
  quote_success_desc: 'Nos pondremos en contacto contigo en menos de 24 horas con la mejor propuesta.',
  quote_new: 'Nueva cotización',
  map_badge: 'Encuéntranos',
  map_title: 'Visítanos en',
  map_title_accent: 'Santo Domingo Este',
  map_dir_label: 'Dirección',
  map_maps: 'Abrir en Google Maps',
  map_hours_label: 'Horarios',
  map_mon_sat: 'Lunes – Sábado',
  map_mon_fri: 'Lunes – Viernes',
  map_sat: 'Sábado',
  map_sun: 'Domingo',
  map_holidays: 'Feriados',
  map_closed: 'Cerrado',
  map_contact_label: 'Contacto',
  custom_badge: 'Ensamblajes',
  custom_title: 'Personalízala a tu medida',
  custom_desc: 'Construimos la PC de tus sueños con componentes de alta calidad, optimizada para tu estilo y necesidades.',
  custom_cta: 'Arma tu PC',
  svc_asm_basic_f1: 'Ensamblaje de componentes',
  svc_asm_basic_f2: 'Instalación de Windows / Linux',
  svc_asm_basic_f3: 'Prueba de arranque básica',
  svc_asm_basic_f4: 'Garantía 30 días mano de obra',
  svc_asm_basic_f5: 'Entrega en 24 horas',
  svc_asm_pro_f1: 'Ensamblaje profesional con gestión de cables',
  svc_asm_pro_f2: 'Instalación y activación de Windows',
  svc_asm_pro_f3: 'Prueba de estrés CPU + GPU (2h)',
  svc_asm_pro_f4: 'Instalación de drivers y software base',
  svc_asm_pro_f5: 'Optimización BIOS / XMP',
  svc_asm_pro_f6: 'Garantía 90 días mano de obra',
  svc_asm_pro_f7: 'Entrega en 48 horas',
  svc_asm_ent_f1: 'Todo lo del plan Pro',
  svc_asm_ent_f2: 'Desde 5 equipos en adelante',
  svc_asm_ent_f3: 'Configuración en red LAN',
  svc_asm_ent_f4: 'Inventario y etiquetado',
  svc_asm_ent_f5: 'Soporte post-instalación 6 meses',
  svc_asm_ent_f6: 'Garantía extendida 1 año',
  svc_asm_ent_f7: 'Visita a instalaciones incluida',
  svc_mnt_basic_f1: 'Limpieza externa e interna',
  svc_mnt_basic_f2: 'Soplado de polvo con compresor',
  svc_mnt_basic_f3: 'Revisión de conexiones internas',
  svc_mnt_basic_f4: 'Diagnóstico de temperatura',
  svc_mnt_basic_f5: 'Informe de estado del equipo',
  svc_mnt_deep_f1: 'Desmontaje y limpieza total',
  svc_mnt_deep_f2: 'Cambio de pasta térmica premium',
  svc_mnt_deep_f3: 'Limpieza de contactos RAM y GPU',
  svc_mnt_deep_f4: 'Actualización de drivers y BIOS',
  svc_mnt_deep_f5: 'Optimización del sistema',
  svc_mnt_deep_f6: 'Prueba de temperaturas post-limpieza',
  svc_mnt_deep_f7: 'Garantía 6 meses en mano de obra',
  svc_mnt_con_f1: 'Mantenimiento mensual programado',
  svc_mnt_con_f2: 'Inventario actualizado de hardware',
  svc_mnt_con_f3: 'Respuesta prioritaria en fallas',
  svc_mnt_con_f4: 'Informes mensuales de estado',
  svc_mnt_con_f5: 'Recomendaciones de actualización',
  svc_mnt_con_f6: 'Descuento 20% en repuestos',
  svc_sup_rem_f1: 'Soporte vía TeamViewer / AnyDesk',
  svc_sup_rem_f2: 'Resolución de problemas de software',
  svc_sup_rem_f3: 'Eliminación de virus y malware',
  svc_sup_rem_f4: 'Configuración de red y periféricos',
  svc_sup_rem_f5: 'Horario: Lunes – Sábado 9am-6pm',
  svc_sup_ons_f1: 'Técnico en tu ubicación',
  svc_sup_ons_f2: 'Diagnóstico completo en sitio',
  svc_sup_ons_f3: 'Reparación hardware y software',
  svc_sup_ons_f4: 'Incluye 2 horas de trabajo',
  svc_sup_ons_f5: 'Horas adicionales RD$600/h',
  svc_sup_ons_f6: 'Santo Domingo y alrededores',
  svc_sup_ons_f7: 'Garantía 30 días en reparación',
  svc_sup_sla_f1: 'Soporte ilimitado remoto',
  svc_sup_sla_f2: 'Visitas presenciales incluidas (4/mes)',
  svc_sup_sla_f3: 'Tiempo de respuesta &lt; 2 horas',
  svc_sup_sla_f4: 'Soporte fuera de horario (urgencias)',
  svc_sup_sla_f5: 'Backup y recuperación de datos',
  svc_sup_sla_f6: 'Reporte mensual de incidencias',
  alert_badge: 'Alertas Inteligentes',
  alert_title1: 'Nunca pierdas una',
  alert_title2: 'Oferta o Bajada de Precio',
  alert_body: 'Suscríbete a nuestro newsletter y recibe las mejores ofertas directamente en tu email. O configura alertas específicas para que te avisemos cuando el producto que quieres baje de precio.',
  alert_f1_title: 'Newsletter Semanal',
  alert_f1_desc: 'Las mejores ofertas y novedades tech cada semana',
  alert_f2_title: 'Alertas de Precio',
  alert_f2_desc: 'Te notificamos cuando el precio baje de tu objetivo',
  alert_f3_title: 'Alertas por WhatsApp',
  alert_f3_desc: 'Opción de recibir notificaciones por WhatsApp también',
  alert_f4_title: 'Sin Spam, Garantizado',
  alert_f4_desc: 'Nos limitamos solo a lo que pides, nada más',
  alert_tab_newsletter: 'Newsletter',
  alert_tab_price: 'Alerta de Precio',
  alert_success_title: '¡Listo!',
  alert_success_newsletter: 'Te añadimos a nuestra lista de newsletters. Pronto recibirás las mejores ofertas.',
  alert_success_alert: 'Tu alerta de precio fue configurada. Te notificaremos en cuanto baje.',
  alert_config_another: 'Configurar otra alerta',
  alert_name: 'Nombre *',
  alert_wa_label: 'WhatsApp',
  alert_wa_note: '(para alertas instantáneas)',
  alert_wa_ph: '(809) 000-0000 — Opcional',
  alert_category: 'Categoría del Producto *',
  alert_category_ph: 'Seleccionar categoría...',
  alert_cat_1: 'GPUs / Tarjetas de Video',
  alert_cat_2: 'CPUs / Procesadores',
  alert_cat_3: 'Memoria RAM',
  alert_cat_4: 'Almacenamiento NVMe / SSD',
  alert_cat_5: 'Monitores Gaming',
  alert_cat_6: 'Sillas Gaming',
  alert_cat_7: 'Fuentes de Poder',
  alert_cat_8: 'Gabinetes',
  alert_cat_9: 'Kits de Enfriamiento',
  alert_cat_10: 'Periféricos',
  alert_product: 'Producto Específico',
  alert_product_ph: 'Ej: RTX 4070 Super, Ryzen 7 7700X...',
  alert_target_price: 'Precio Objetivo (RD$)',
  alert_interests: 'Intereses (opcional)',
  alert_int_deals: 'Gaming Deals',
  alert_int_new: 'Nuevos Productos',
  alert_int_builds: 'Ensamblajes',
  alert_int_news: 'Noticias Tech',
  alert_error: 'Error al enviar. Intenta de nuevo.',
  alert_btn_newsletter: 'Suscribirme al Newsletter',
  alert_btn_price: 'Activar Alerta de Precio',
  alert_processing: 'Procesando...',
  alert_no_spam: 'Sin spam. Cancela cuando quieras.',
  book_available_today: 'Citas disponibles hoy',
  book_page_title: 'Agenda tu',
  book_page_highlight: 'Cita Técnica',
  book_page_body: 'Selecciona fecha y hora, llena el formulario y un técnico certificado se presentará en tu ubicación o te atenderá en nuestra tienda.',
  book_perk1_title: 'Horarios Flexibles',
  book_perk1_desc: 'Lun–Sáb 9AM-6PM',
  book_perk2_title: 'En tu Ubicación',
  book_perk2_desc: 'Servicio a domicilio en SDN Este',
  book_perk3_title: 'Confirmación Inmediata',
  book_perk3_desc: 'Confirmación por WhatsApp y email',
  book_perk4_title: 'Técnicos Certificados',
  book_perk4_desc: 'CompTIA A+ y Network+ certificados',
  book_step1: 'Paso 1',
  book_step1_sub: 'Elige fecha y hora',
  book_step2: 'Paso 2',
  book_step2_sub: 'Completa tus datos',
  book_policy_title: 'Política de Citas',
  book_policy_1: 'Llega 5 minutos antes de tu hora agendada',
  book_policy_2: 'Si necesitas cancelar, avísanos con 2 horas de anticipación',
  book_policy_3: 'Diagnóstico inicial incluido en el costo del servicio',
  book_policy_4: 'Servicio a domicilio disponible en Santo Domingo Este',
  book_faq_section_title: 'Preguntas sobre las Citas',
  book_faq_q1: '¿Cuánto dura una cita?',
  book_faq_a1: 'Las citas tienen 1 hora de duración. Trabajos más complejos pueden requerir dejar el equipo en tienda.',
  book_faq_q2: '¿Hay costo por el diagnóstico?',
  book_faq_a2: 'El diagnóstico básico es gratuito con cualquier servicio agendado. Solo pagas el servicio que autorices.',
  book_faq_q3: '¿Puedo cancelar mi cita?',
  book_faq_a3: 'Sí, comunícate con nosotros por WhatsApp con al menos 2 horas de anticipación.',
  book_faq_q4: '¿Traen repuestos al domicilio?',
  book_faq_a4: 'Los técnicos llevan herramientas y repuestos comunes. Para partes especiales, se coordina una segunda visita.',
};
